import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions';
import Immutable from 'immutable';
import { connect } from 'react-redux';

import Gnb from '../../components/Gnb';

export class CustomChatSchemePage extends Component {
  constructor(props) {
    super(props);

    this.gotoApp = this.gotoApp.bind(this);
  }

  componentDidMount() {
    this.gotoApp();
  }

  gotoApp() {
    const { chatId, phase, message } = this.props;
    const encodedUUID = chatId !== undefined && chatId.indexOf('%40') !== 0 ? encodeURIComponent(chatId) : chatId;
    const protocol = phase == 'sandbox' ? 'alphaplus' : 'kakaoplus';
    if (message) {
      const encodedMessage = encodeURIComponent(message);
      console.log(encodedMessage);
      daumtools.web2app({
        urlScheme: `${protocol}://plusfriend/talk/bot/${encodedUUID}/${encodedMessage}`,
        intentURI: `intent://plusfriend/talk/bot/${encodedUUID}/${encodedMessage}#Intent;scheme=kakaoplus;package=com.kakao.talk;end;`,
        storeURL: 'https://itunes.apple.com/app/id362057947',
        appName: 'KakaoTalk'
      });
    } else {
      daumtools.web2app({
        urlScheme: `${protocol}://plusfriend/talk/bot/${encodedUUID}`,
        intentURI: `intent://plusfriend/talk/bot/${encodedUUID}#Intent;scheme=kakaoplus;package=com.kakao.talk;end;`,
        storeURL: 'https://itunes.apple.com/app/id362057947',
        appName: 'KakaoTalk'
      });
    }
  }

  render() {
    const { device } = this.props;

    return (
      <div style={{ height: '100%' }}>
        <div id="kakaoIndex">
          <a href="#kakaoBody">본문 바로가기</a>
          <a href="#kakaoGnb">메뉴 바로가기</a>
        </div>
        <div id="kakaoWrap">
          <Gnb device={device}/>
          <div id="kakaoContent" className="cont_plus" role="main">
            <div id="mArticle">
              <h2 id="kakaoBody" className="screen_out">포스트 본문영역</h2>
              {
                device.getIn(['os', 'name']) !== 'Android' && device.getIn(['os', 'name']) !== 'iOS' ?
                (
                  <div className="info_err">
                    <span className="ico_plus"></span>
                    <p className="tit_err">지원하지 않는 기기입니다.</p>
                    <p className="desc_info">카카오톡 채널은 안드로이드 및 iOS 기반의
                    모바일 기기에서만 이용 가능합니다.</p>
                  </div>
                ) :
                (
                  <div className="info_condition">
                    <span className="ico_plus ico_friend" />
                    <p className="tit_info">카카오톡이 실행됩니다.</p>
                    <p className="desc_info">카카오톡이 아직 없다면?</p>

                    <a style={{backgroundColor: 'rgb(255,223,44)', borderRadius: 5, borderColor: 'rgb(255,223,44)', textAlign: 'center', padding: '15px 30px', display: 'inline-block', marginTop: 24, textDecoration: 'none', color: '#000'}} onClick={this.gotoApp}>설치하기</a>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { match: { params }}) => {
  const { device, page, phase } = state;

  const { chatId } = params;

  if (params.message) {
    return { device, page, chatId, phase, message: params.message };
  }
  return { device, page, chatId, phase, message: undefined };
};

export default connect(
  mapStateToProps,
  (dispatch) => bindActionCreators({
    showModal: actions.showModal
  }, dispatch)
)(CustomChatSchemePage);



// WEBPACK FOOTER //
// ./src/containers/CustomSchemePage/bot.js